{
  "alert": "Alerte",
  "dismiss": "Rejeter"
}